

class Cart{
    items = [];
    createdUTC = Date.now();

    static from(json){
        return Object.assign(new Cart(), json);
    }

    get totalQuantity() {
        const sum = this.items.reduce(
            (accumulator, currentValue) => accumulator + currentValue.quantity
            , 0);
        return sum;
    }
}

export default Cart;